import { LogBookErrorFilter } from "./LogBookErrorFilter";

export class LogBookQueryFilter {
    pageIndex: number;
    pageSize: number;
    logBookErrorFilter: LogBookErrorFilter;

    constructor(pageIndex: number, pageSize: number, logBookErrorFilter: LogBookErrorFilter) {
        this.logBookErrorFilter = logBookErrorFilter;
        this.pageIndex = pageIndex;
        this.pageSize = pageSize;
    }
}